import React from 'react';
import ReactLoading from 'react-loading';
import PropTypes from 'prop-types';

const loaderHeight = 50;
const loaderWidth = 50;

const LoadingSpacer = ({ isLoading, height, shouldFlushBottom }) => {
    return (
        <div
            className={isLoading ? 'pulsating-background' : ''}
            style={{
                height: height + 'px',
                width: '100%',
                display: 'flex',
            }}>
            {isLoading && height > loaderHeight && (
                <div
                    style={{
                        margin: '0px auto',
                        padding: '50px 0',
                        maxWidth: loaderWidth,
                        marginTop: shouldFlushBottom ? 'auto' : '0',
                    }}>
                    <ReactLoading type={'spin'} color={'#262f3d'} height={loaderHeight} width={loaderWidth} />
                </div>
            )}
        </div>
    );
};

export default LoadingSpacer;

LoadingSpacer.propTypes = {
    isLoading: PropTypes.bool,
    height: PropTypes.number, // Number of px 
    shouldFlushBottom: PropTypes.bool,
};
